module.exports = __webpack_public_path__ + "img/de.ad132d3b.svg";